module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAORJREFUOE+Vk8FtwkAURN8oV0qAKtIANJBLiuACSgWcKIFcKCKXNBAaoAoogSua6Fu2tY6/FzKXlb3eN0/WX9n+AL4kXflHbM+Bd9leAt/ADviUdK9xbL8AG2APvCk+tv0DBOgMrCXFOortV+AIxHqStOoAcTggkTA4hJGkW1swaxu3QBhEVpJODeCPRffqAsSBSAAXhVLTHs8loLR49Dub9gFgwiID9e0Z4BmLvn0EeMJi0D4FqFkM2lNAxWLUXgNkFqP2SUBikbY/ApQWaXsVUFjQTV02FP0kZpvtTQ1AM3VZfgHTJmW6SfkGNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiantou.png
// module id = gEds
// module chunks = 1